/* eslint-disable import/no-unresolved */
/* eslint-disable jsx-a11y/control-has-associated-label */
import { useMutation, useQuery } from '@apollo/client';
import { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';

import { CREATE_TENANT, ONBOARD_ORGNIZATION, CREATE_USER } from 'Apollo/Mutations';
import { GET_USER_INFO } from 'Apollo/Queries';
import {
    leftNavigationItemsVar, showCrossReportConfigVar, showDataReconMenusVar,
    showReportMenuVar, currentLeftMenuVar, moduleIdVar,
} from 'Apollo/config';
import { ModuleEnum } from 'constants';
import { listItems } from './utils';
import CreateTenant from '../components/CreateTenant';

const productName = process.env.REACT_APP_PRODUCT;

const CreateTenantContainer = () => {
    const history = useHistory();
    const [tenantName, setTenantName] = useState('');
    const [tenantType, setTenantType] = useState('');
    const [allowedDomains, setAllowedDomains] = useState('');
    const [onboardOrganizationAdmin, setOnboardOrganizationAdmin] = useState('');
    const [tenantNameError, setTenantNameError] = useState(false);
    const [tenantTypeError, setTenantTypeError] = useState(false);
    const [adminEmailError, setAdminEmailError] = useState(false);
    const [adminErrorMsg, setAdminErrorMsg] = useState('');
    const [showSuccssAlert, setShowSuccssAlert] = useState(false);
    const [showErrorAlert, setShowErrorAlert] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [firstNameError, setFirstNameError] = useState(false);
    const [lastName, setLastName] = useState('');
    const [lastNameError, setLastNameError] = useState(false);

    /* Apollo query to fetch logged user details */
    const { data = {} } = useQuery(GET_USER_INFO);

    /* Apollo mutation to create new tenant */
    const [createTenant, { loading }] = useMutation(CREATE_TENANT, {
        variables: {
            input: {
                name: tenantName,
                type: tenantType,
                iamAllowedDomains: allowedDomains,
                iamOnboardOrganizationAdmin: onboardOrganizationAdmin,
            },
        },
    });

    /* Apollo mutation to onboard onrgnization */
    const [onboardOrg, { loading: isOnBoardLoading }] = useMutation(ONBOARD_ORGNIZATION, {
        variables: {
            input: {
                product: productName,
                organizationName: tenantName,
                adminEmail: onboardOrganizationAdmin,
            },
        },
    });

    /* Apollo mutation to create user */
    const [createUser, { loading: createUserLoading }] = useMutation(CREATE_USER);

    /* form validation */
    const checkValidation = () => {
        if (tenantName.trim() === '') {
            setTenantNameError(true);
        } else {
            setTenantNameError(false);
        }

        if (tenantType.trim() === '') {
            setTenantTypeError(true);
        } else {
            setTenantTypeError(false);
        }

        if (firstName.trim() === '') {
            setFirstNameError(true);
        } else {
            setFirstNameError(false);
        }

        if (lastName.trim() === '') {
            setLastNameError(true);
        } else {
            setLastNameError(false);
        }
    };

    /* Calls  onboardOrg(),createUser() */
    const onSave = async () => {
        const isTenantNameError = (tenantName === '' || tenantNameError);
        const isFirstNameError = (firstName === '' || firstNameError);
        const isLastNameError = (lastName === '' || lastNameError);
        const isTenantTypeError = (tenantType === '' || tenantTypeError);
        const isAdminError = (onboardOrganizationAdmin === '' || adminEmailError);
        const isInValidTenantDetails = isTenantNameError || isTenantTypeError;
        const isNameError = isFirstNameError && isLastNameError;

        if (!isInValidTenantDetails && !isNameError && !isAdminError) {
            setShowErrorAlert(false);
            setShowSuccssAlert(false);
            try {
                const _onboardResponse = await onboardOrg();
                if (_onboardResponse.data.IAMonboardOrganization.status === 'SUCCESS') {
                    try {
                        const _createTenantResponse = await createTenant({
                            variables: {
                                input: {
                                    name: tenantName,
                                    type: tenantType,
                                    iamOnboardOrganizationAdmin: onboardOrganizationAdmin,
                                    iamOrganizationId: _onboardResponse.data.IAMonboardOrganization.organization.organizationId,
                                },
                            },
                        });
                        if (_createTenantResponse.data.createTenant?.tenantId) {
                            try {
                                const _createUserRes = await createUser({
                                    variables: {
                                        input: {
                                            firstName,
                                            lastName,
                                            iamTenantId: _createTenantResponse.data.createTenant.tenantId,
                                            email: _onboardResponse.data.IAMonboardOrganization.admin.email,
                                            requestingUserEmail: data?.getUser?.email,
                                            iamRole: _onboardResponse.data.IAMonboardOrganization.admin.role,
                                            isCreateUser: false,
                                        },
                                    },
                                });
                                if (_createUserRes.data.createUser) {
                                    setShowSuccssAlert(true);
                                }
                            } catch (_createUserError) {
                                setAdminErrorMsg('An error ocurred while creating Tenant.');
                                setShowErrorAlert(true);
                            }
                        }
                    } catch (_createTenantError) {
                        setAdminErrorMsg('An error ocurred while creating Tenant.');
                        setShowErrorAlert(true);
                    }
                }
            } catch (_onboardError) {
                setAdminErrorMsg(_onboardError.message);
                setShowErrorAlert(true);
            }
        }
    };

    /* Breadcrumb items configuration */
    const breadcrumbItems = [
        {
            link: '',
            value: (
                <span
                    className="appkiticon icon-home-fill font-16"
                    onClick={
                        () => {
                            showReportMenuVar(false);
                            history.push('/');
                            showCrossReportConfigVar(false);
                            leftNavigationItemsVar([]);
                            moduleIdVar(null);
                        }
                    }
                    role="presentation"
                />
            ),
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text" onClick={() => history.goBack()} role="presentation">Tenant Management</span>,
        },
        {
            link: '',
            value: <span className="a-breadcrumb-item-text">Create Tenant</span>,
        },
    ];

    const validateEmail = emailId => {
        setAdminErrorMsg('');
        setShowErrorAlert(false);
        const pattern = /^[a-zA-Z0-9+_._]+@[a-zA-Z0-9.]+$/;
        if (!pattern.test(emailId)) {
            setAdminEmailError(true);
        } else if (!emailId.endsWith('@pwc.com') && !emailId.endsWith('@us.pwc.com')) {
            setAdminEmailError(true);
            setAdminErrorMsg('Only @pwc.com and @us.pwc.com domains are allowed!');
            setShowErrorAlert(true);
        } else {
            setAdminEmailError(false);
        }
    };

    useEffect(() => {
        leftNavigationItemsVar(listItems);
        showCrossReportConfigVar(false);
        showDataReconMenusVar(false);
        showReportMenuVar(false);
        currentLeftMenuVar(ModuleEnum.TENANT);
    }, []);

    return (
        <CreateTenant
            history={history}
            breadcrumbItems={breadcrumbItems}
            checkValidation={checkValidation}
            onSave={onSave}
            loading={loading}
            isOnBoardLoading={isOnBoardLoading}
            showSuccssAlert={showSuccssAlert}
            setShowSuccssAlert={setShowSuccssAlert}
            showErrorAlert={showErrorAlert}
            setShowErrorAlert={setShowErrorAlert}
            adminErrorMsg={adminErrorMsg}
            tenantName={tenantName}
            setTenantName={setTenantName}
            tenantNameError={tenantNameError}
            setTenantType={setTenantType}
            tenantType={tenantType}
            tenantTypeError={tenantTypeError}
            onboardOrganizationAdmin={onboardOrganizationAdmin}
            setOnboardOrganizationAdmin={setOnboardOrganizationAdmin}
            adminEmailError={adminEmailError}
            allowedDomains={allowedDomains}
            setAllowedDomains={setAllowedDomains}
            firstName={firstName}
            setFirstName={setFirstName}
            firstNameError={firstNameError}
            lastName={lastName}
            setLastName={setLastName}
            lastNameError={lastNameError}
            createUserLoading={createUserLoading}
            setFirstNameError={setFirstNameError}
            setLastNameError={setLastNameError}
            setTenantNameError={setTenantNameError}
            setTenantTypeError={setTenantTypeError}
            validateEmail={validateEmail}
        />
    );
};

export default CreateTenantContainer;
